<app-page-title title="Frequência"></app-page-title>
<div *ngIf="frequency" class="painel">
  <h3 class="theme">{{ frequency?.theme }}</h3>

  <h3 class="date"><mat-icon color="#fff">article</mat-icon>{{ frequency[0]?.groupWords?.theme }}</h3>
  <!-- <h3 class="date"><mat-icon color="#fff">checklist_rti</mat-icon>{{ frequency[0]?.groupWords?.theme }}</h3> -->
  <h3 class="date">
    <mat-icon color="#fff">event_available</mat-icon>{{ frequency[0]?.created_at | date: 'dd/MM/yyyy' }}
  </h3>

  <br />
  <div *ngFor="let frequencyUser of frequency[0]?.frequencyUsers">
    <p [class]="frequencyUser.present ? 'present' : 'absent'">
      {{ frequencyUser.user.name }}
    </p>
  </div>

  <br />
  <br />
  <p>{{ frequency[0]?.visitors?.length >= 1 ? frequency[0]?.visitors?.split(';').length : 0 }} - Visitante(s)</p>
  <div *ngIf="frequency[0]?.visitors.split(';')[0].length > 0">
    <div *ngFor="let visitors of frequency[0]?.visitors.split(';')">
      <p class="visitor">
        {{ visitors }}
      </p>
    </div>
  </div>
  <div><br /><b>Observações</b><br />{{ frequency[0]?.obs || 'sem observações' }}</div>
  <br />
</div>
